import type { CommonOptions } from "@/shared/ui";

export const BANKS: CommonOptions = [
	{
		value: "budapestbank",
		label: "Budapest Bank",
	},
	{
		value: "cib",
		label: "CIB Bank",
	},
	{
		value: "erste",
		label: "Erste Bank",
	},
	{
		value: "granit",
		label: "Gránit Bank",
	},
	{
		value: "kh",
		label: "K&H Bank",
	},
	{
		value: "magnet",
		label: "MagNet Bank",
	},
	{
		value: "mbh",
		label: "MBH Bank",
	},
	{
		value: "otp",
		label: "OTP Bank",
	},
	{
		value: "raiffeisen",
		label: "Raiffeisen Bank",
	},
	{
		value: "sberbank",
		label: "Sberbank",
	},
	{
		value: "unicredit",
		label: "UniCredit Bank",
	},
];

export function getBankName(code: string): string {
	return BANKS.find((bank) => bank.value === code)?.label;
}
